import React from 'react';
import {
  Box,
  Typography,
  Chip,
  Divider,
} from '@mui/material';
import {
  Tv as TvIcon,
  CalendarToday as CalendarIcon,
} from '@mui/icons-material';

const DouxeCoupsDeMidiProject: React.FC = () => {
  return (
    <Box>
      {/* Header avec titre et image */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
        <img
          src="/TV/12CDM.png"
          alt="Logo Les 12 Coups de Midi"
          style={{
            width: '64px',
            height: '64px',
            objectFit: 'contain',
            filter: 'drop-shadow(2px 2px 4px rgba(167, 139, 250, 0.3))',
          }}
        />
        <Typography
          variant="h4"
          component="h2"
          sx={{ 
            background: 'linear-gradient(135deg, #a78bfa 0%, #14b8a6 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            fontWeight: 'bold' 
          }}
        >
          Les 12 Coups de Midi
        </Typography>
      </Box>

      {/* Statut et date */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <CalendarIcon sx={{ fontSize: '1rem', color: 'text.secondary' }} />
          <Typography variant="body2" color="text.secondary">
            2019
          </Typography>
        </Box>
      </Box>

      {/* Description */}
      <Typography
        variant="body1"
        sx={{ mb: 3, lineHeight: 1.6 }}
      >
        Mission de migration complète du système technique de l'émission de TF1 "Les 12 Coups de Midi". 
        Modernisation de l'ensemble des composants logiciels incluant la gestion des buzzers, du scoring et 
        l'habillage graphique. Participation active au suivi plateau lors de plusieurs émissions.
      </Typography>

      <Divider sx={{ my: 3 }} />

      {/* Missions réalisées */}
      <Box sx={{ mb: 3 }}>
        <Typography 
          variant="h6" 
          gutterBottom 
          sx={{ 
            background: 'linear-gradient(135deg, #a78bfa 0%, #14b8a6 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            fontWeight: 'bold' 
          }}
        >
          Missions réalisées
        </Typography>
        <Box sx={{ 
          display: 'grid', 
          gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, 
          gap: 2 
        }}>
          <Box>
            <Typography variant="body2" sx={{ mb: 1 }}>
              • Migration du système de buzzers
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              • Modernisation de l'habillage graphique
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              • Refonte du système étoile mystère
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              • Intégration nouveaux moteurs de rendu
            </Typography>
          </Box>
          <Box>
            <Typography variant="body2" sx={{ mb: 1 }}>
              • Tests et validation plateau
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              • Suivi technique en émission
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              • Formation équipes techniques
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              • Maintenance et support
            </Typography>
          </Box>
        </Box>
      </Box>

      <Divider sx={{ my: 3 }} />

      {/* Technologies (générales) */}
      <Box sx={{ mb: 3 }}>
        <Typography 
          variant="h6" 
          gutterBottom 
          sx={{ 
            background: 'linear-gradient(135deg, #a78bfa 0%, #14b8a6 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            fontWeight: 'bold' 
          }}
        >
          Domaines techniques
        </Typography>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
          {['Migration logicielle', 'Systèmes de diffusion', 'Intégration hardware', 'Moteurs de rendu', 'Support plateau', 'Tests en production'].map((tech) => (
            <Chip
              key={tech}
              label={tech}
              variant="filled"
              size="small"
              sx={{
                background: 'linear-gradient(135deg, rgba(167, 139, 250, 0.1) 0%, rgba(20, 184, 166, 0.1) 100%)',
                color: '#a78bfa',
                border: '1px solid rgba(167, 139, 250, 0.3)',
                '&:hover': {
                  background: 'linear-gradient(135deg, rgba(167, 139, 250, 0.2) 0%, rgba(20, 184, 166, 0.2) 100%)',
                },
              }}
            />
          ))}
        </Box>
      </Box>

      <Divider sx={{ my: 3 }} />

      {/* Défis techniques */}
      <Box sx={{ mb: 3 }}>
        <Typography 
          variant="h6" 
          gutterBottom 
          sx={{ 
            background: 'linear-gradient(135deg, #a78bfa 0%, #14b8a6 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            fontWeight: 'bold' 
          }}
        >
          Défis techniques relevés
        </Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>
          <strong>Intégration multi-systèmes :</strong> Coordonner la communication entre 
          les nouveaux moteurs de rendu et les anciens systèmes.
        </Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>
          <strong>Fiabilité critique :</strong> Garantir une stabilité absolue pour une 
          émission diffusée quotidiennement en direct, avec gestion proactive des incidents 
          et procédures de récupération rapide.
        </Typography>
        <Typography variant="body2">
          <strong>Expérience plateau :</strong> Maintenir une ergonomie optimale pour 
          l'équipe de production tout en modernisant l'ensemble des outils techniques, 
          formation des utilisateurs aux nouveaux workflows.
        </Typography>
      </Box>

      <Divider sx={{ my: 3 }} />
    </Box>
  );
};

export default DouxeCoupsDeMidiProject;
